import { fastApi } from "@/redux/api/fastApi";

const videoDashboardApi = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    // ----------- BRAND / COMPANY DETAILS ------------

    // POST: Add brand/company details
    addBrandDetails: builder.mutation({
      query: (payload) => ({
        url: `/company_details?email=${payload.email}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BrandCart", "BrandDetails"],
    }),

    // GET: Fetch brand/company details
    getBrandDetails: builder.query({
      query: (email) => `/company_details?email=${email}`,
      providesTags: ["BrandDetails"],
    }),

    // PATCH: Update brand/company details
    updateBrandDetails: builder.mutation({
      query: ({ email, ...data }) => ({
        url: `/company_details?email=${email}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["BrandDetails", "BrandCart"],
    }),

    // ------------------ PRODUCTS ---------------------

    // GET: Get products list
    getProducts: builder.query({
      query: ({ email, teamId }) =>
        `/products/list?email=${email}&teamId=${teamId}`,
      providesTags: ["Products"],
    }),

    // DELETE: Delete a product
    deleteProduct: builder.mutation<
      any,
      { email: string; brand: string; product: string; country: string }
    >({
      query: ({ email, brand, product, country }) => ({
        url: `/delete?email=${encodeURIComponent(
          email
        )}&brand=${encodeURIComponent(brand)}&product=${encodeURIComponent(
          product
        )}&country=${encodeURIComponent(country)}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Products"],
    }),

    // ---------------- VIDEO ANALYSIS ------------------

    // POST: Start video analysis
    addVideoAnalysis: builder.mutation({
      query: (payload) => ({
        url: `/analyze-complete/start?email=${payload.email}`,
        method: "POST",
        body: { video_url: payload.videoUrl },
      }),
    }),

    // GET: Get result by task ID
    getVideoAnalysis: builder.query({
      query: ({ taskID }) => `/analyze-complete/task-result?task_id=${taskID}`,
    }),

    // GET: Previous analysis
    getPreviousAnalysisList: builder.query({
      query: ({ email }) => `/analyze/previous?email=${email}`,
    }),

    // GET: Previous analysis details
    getPreviousAnalysisDetails: builder.query({
      query: ({ video_url, email }) =>
        `/analyze-complete/result?video_url=${video_url}&email=${email}`,
    }),
  }),
});

export const {
  useAddBrandDetailsMutation,
  useGetBrandDetailsQuery,
  useUpdateBrandDetailsMutation,
  useGetProductsQuery,
  useDeleteProductMutation,
  useAddVideoAnalysisMutation,
  useGetVideoAnalysisQuery,
  useGetPreviousAnalysisListQuery,
  useGetPreviousAnalysisDetailsQuery,
  useLazyGetPreviousAnalysisDetailsQuery,
} = videoDashboardApi;
